import cmaApi from "../../../../../api/cmaApi";
import { appRoutes } from "../../../../../routes/routes";
import LandingList from "../../LandingList";

const FeaturesList = () => (
  <LandingList
    config={{
      title: "CMA · Tính năng",
      listPath: appRoutes.CMA.LANDING.FEATURES.LIST,
      addPath: appRoutes.CMA.LANDING.FEATURES.ADD,
      queryKey: "cma_landing_features",
      getList: cmaApi.getLandingFeatures,
      editItem: cmaApi.editLandingFeature,
      deleteItem: cmaApi.deleteLandingFeature,
      titleField: "ten_vi",
      subtitleField: "mota_vi",
    }}
  />
);

export default FeaturesList;
